export default "__VITE_ASSET__D_3I3mrz__"